import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { makeGetCurrentMenu } from '../selectors/menus'
import { getVenueName } from '../selectors/venue'
import { makeGetActiveAttendant } from '../selectors/attendant'
import { makeGetOpenAndClosedOrdersCount } from '../selectors/order'

import AttendantSummary from '../components/AttendantSummary'

const mapStateToProps = (state) => {
  const getMenu = makeGetCurrentMenu()
  const menu = getMenu(state)
  const menuName = menu.name
  const venueName = getVenueName(state)
  const deviceUuid = localStorage.getItem('device_id')
  const attendantName = makeGetActiveAttendant()(state)?.name ?? ''
  const [openOrdersCount, closedOrdersCount] = makeGetOpenAndClosedOrdersCount()(state)

  return {
    attendantName,
    deviceUuid,
    menuName,
    venueName,
    openOrdersCount,
    closedOrdersCount,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  const replace = props?.history?.replace ?? (() => {})

  return {
    onClose: () => replace('/tabs'),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AttendantSummary))
